import { bigImg, overlayBlock } from "../services/variables";

function bigImage(e) {
	const img = e.target.closest(".photo__img");
	overlayBlock.classList.add("photo__overlay_active");
	const linkImg = img.getAttribute("src");
	bigImg.setAttribute("src", linkImg);
}

export default bigImage;
